import { Component, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SvgIconComponent } from 'app/shared/components/svg-icon/svg-icon.component';
import { DropdownFilterComponent } from 'app/shared/components/dropdown-filter/dropdown-filter.component';

import { ClickOutsideDirective } from 'app/shared/directives/click-outside.directive';

import { IDiscoverFilter, INationalityFilter } from 'app/interfaces/discover.interfaces';
import { ISvgConfig } from 'app/shared/interfaces/svg.interfaces';

import { EDiscoverFilter } from 'app/enums/discover.enums';
import { ESvgTypes } from 'app/shared/enums/svg.enums';

import { fadeAnimation, fadeAnimationSequence } from '../../shared/animations/fade.animations';

@Component({
  selector: 'stxt-discover-filters',
  standalone: true,
  imports: [CommonModule, DropdownFilterComponent, ClickOutsideDirective, SvgIconComponent],
  templateUrl: './discover-filters.component.html',
  styleUrl: './discover-filters.component.scss',
  animations: [fadeAnimation, fadeAnimationSequence]
})
export class DiscoverFiltersComponent {
  @Input() nationalityFilters: INationalityFilter[] = [];
  @Input() filters: IDiscoverFilter[] = [];
  @Output() filterSelected: EventEmitter<string | string[] | INationalityFilter[]> =
    new EventEmitter<string | string[] | INationalityFilter[]>();
  isShowFilter: boolean = false;
  arrowDownSvg: ISvgConfig = {
    fill: ESvgTypes.None,
    name: 'arrow_down'
  };
  nationalityFiltersList: INationalityFilter[] = [];
  selectedFilters: string[] = [EDiscoverFilter.ForYou];
  activeFilter: IDiscoverFilter = this.filters[0];

  constructor(private readonly cdr: ChangeDetectorRef) {}

  selectFilter(filter: IDiscoverFilter): void {
    if (filter.isMultiple) {
      this.handleMultipleFilter(filter);
      return;
    }

    if (filter.value === EDiscoverFilter.ForYou) {
      this.handleForYouFilter();
      return;
    }

    this.handleSingleFilter(filter);
  }

  selectNationalityFilter(filters: INationalityFilter[]): void {
    this.nationalityFiltersList = filters;
    this.selectedFilters = this.selectedFilters.filter(f => f !== EDiscoverFilter.ForYou);
    this.filterSelected.emit(filters);
    this.checkFiltersLength();
  }

  isFilterActive(filter: IDiscoverFilter): boolean {
    if (filter.isMultiple) {
      return this.activeFilter === filter && this.nationalityFiltersList.length > 0;
    }
    return this.selectedFilters.includes(filter.value);
  }

  private handleMultipleFilter(filter: IDiscoverFilter): void {
    this.isShowFilter = !this.isShowFilter;
    this.activeFilter = filter;
    this.cdr.detectChanges();
  }

  private handleForYouFilter(): void {
    this.selectedFilters = [EDiscoverFilter.ForYou];
    this.nationalityFiltersList = [];
    this.filterSelected.emit(EDiscoverFilter.ForYou);
    this.cdr.detectChanges();
  }

  private handleSingleFilter(filter: IDiscoverFilter): void {
    const index = this.selectedFilters.indexOf(filter.value);

    if (index > -1) {
      if (filter.value === EDiscoverFilter.ForYou) return;
      this.removeFilter(filter.value);
    } else {
      this.addFilter(filter.value);
    }

    this.filterSelected.emit(this.selectedFilters);
    this.checkFiltersLength();
    this.cdr.detectChanges();
  }

  private checkFiltersLength(): void {
    if (this.nationalityFiltersList.length > 0 || this.selectedFilters.length > 0) return;
    this.selectedFilters = [EDiscoverFilter.ForYou];
  }

  private addFilter(filterValue: string): void {
    this.selectedFilters = this.selectedFilters.filter(f => f !== EDiscoverFilter.ForYou);
    this.selectedFilters.push(filterValue);
  }

  private removeFilter(filterValue: string): void {
    this.selectedFilters.splice(this.selectedFilters.indexOf(filterValue), 1);
  }
}
